<template>
  <branded-detail title="RCS Business Messages (RBM)"
                  sub-title="We have partnered with Google to bring you the new standard for mobile messaging."
                  contact-link="mailto:sales@amio.io"
                  documentation-link="https://docs.amio.io/docs/rbm-rcs-business-messages"
                  api-ref-link="https://docs.amio.io/v1.0/reference#api-rbm"
                  web-link="https://jibe.google.com"
                  support-link="https://developers.google.com/rcs-business-messaging/rbm/"
                  license-link="https://policies.google.com/terms">
    <template slot="logo">
      <img src="~@/assets/img/channels/rcs.svg" alt="RBM logo" height="60px" width="60px">
    </template>
    <template slot="content">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-6 col-10 col-md-8 mt-5 mt-lg-0">
          <h2>The Successor of SMS</h2>
          <ul class="pt-3">
            <li>Rich messages similar to Facebook Messenger</li>
            <li>Available by default on Android smart phones, no need to download an app</li>
            <li>Integrated payments</li>
          </ul>
          <p class="pl-3 mb-5 mb-lg-0">
            RCS Business Messages (RBM) is SMS on steroids. Suddenly, your customers will start receiving RCS messages instead
            of SMS without having to do anything.
          </p>
        </div>
        <div class="col-lg-6 col-12 align-self-center small text-center text-muted mb-5 mb-lg-0">
          <div class="pt-3 px-3 pb-0 bg-light">
          <div class="bg-white p-3">
            <div class="gallery">
              <img src="~@/assets/img/channels/rbm-features.png" alt="RBM features" style="width: 100%;">

            </div>
          </div>
            <div class="text-center small">
              Image by <a href="https://developers.google.com/rcs-business-messaging/rbm/" target="_blank">Google</a>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-7">
        <h2>
          Available Features
        </h2>
      </div>

      <div class="row justify-content-center mt-5">
        <div class="col-10 col-sm-8 col-md-5 col-xl-3">
          <div class="feature-card">
            <span class="headline">Trusted Branding</span>
            <p>Prominent logo makes your brand easily recognizable and thanks to Verified Sender your customers know they can trust you.</p>
          </div>
        </div>

        <div class="w-100 d-block d-md-none"></div>

        <div class="col-10 col-sm-8 col-md-5 col-xl-3 mt-3 mt-md-0">
          <div class="feature-card">
            <span class="headline">Phone Numbers</span>
            <p>Only a phone number is required to contact your customers. This makes transition from SMS even easier.</p>
          </div>
        </div>

        <div class="w-100 d-block d-xl-none"></div>

        <div class="col-10 col-sm-8 col-md-5 col-xl-3 mt-3 mt-xl-0">
          <div class="feature-card">
            <span class="headline">Tracking Events</span>

            <ul>
              <li>Delivery notifications</li>
              <li>Read notifications</li>
              <li>Track when a customer is typing</li>
            </ul>
          </div>
        </div>

        <div class="w-100 d-block d-md-none"></div>

        <div class="col-10 col-sm-8 col-md-5 col-xl-3 mt-3 mt-xl-0">
          <div class="feature-card">
            <span class="headline">Rich Messages</span>
            <ul>
              <li>Calendar events</li>
              <li>Send and receive locations</li>
              <li>Buttons, Carousels and Quick Replies</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row align-items-center justify-content-center mt-7">
        <div class="col-lg-6 col-10 col-md-8 mt-5 mt-lg-0">
          <h2>Use cases</h2>

          <ul class="pt-3 mb-5 mb-lg-0">
            <li>Send <a
              href="https://blog.amio.io/what-is-rcs-and-4-ways-your-business-can-benefit-from-it/#2-ecommerce-order-and-delivery-updates"
              target="_blank">
              notifications and updates
            </a> - package delivery, e-commerce, brands
            </li>
            <li>Give
              <a
                href="https://blog.amio.io/what-is-rcs-and-4-ways-your-business-can-benefit-from-it/#1-providing-customer-service"
                target="_blank">
                customer support
              </a> - connect RBM to your helpdesk and/or build a chatbot
            </li>
            <li>
              Nourish existing customers by sending vouchers & promotions - see <a
              href="https://jibe.google.com/case-studies/subway/"
              target="_blank">
              Subway case study
            </a>
            </li>
            <li><a
              href="https://blog.amio.io/what-is-rcs-and-4-ways-your-business-can-benefit-from-it/#3-sales-offers-and-last-minute-opportunities"
              target="_blank">
              Sales, offers, and last-minute opportunities
            </a></li>
            <li><a
              href="https://blog.amio.io/what-is-rcs-and-4-ways-your-business-can-benefit-from-it/#4-last-step-order-completion-abandoned-cart-retrieval-"
              target="_blank">Abondoned cart retrieval</a></li>
          </ul>
        </div>
        <div class="col-lg-6 col-12 align-self-center small text-center text-muted mb-5 mb-lg-0">
          <div class="flex justify-content-center">
            <img src="~@/assets/img/channels/rbm_airlines.png" alt="RBM features" height="500px">
          </div>
        </div>
      </div>

    </template>
  </branded-detail>
</template>

<script>
  import BrandedDetail from '@/components/common/BrandedDetail'

  export default {
    components: {
      BrandedDetail
    },
    metaInfo: {
      // hack for Safari. If the space is deleted, the whole 'RCS' disappears.
      // also it's a unicode 1/6em space because regular spaces are not cool anymore
      title: ' RCS Business Messages (RBM)'
    }
  }
</script>

<style lang="scss">
  /* vue gallery */
  .blueimp-gallery {
    background-color: rgba(0, 0, 0, 0.6);

    .prev, .next {
      background-color: rgb(255, 255, 255);
      opacity: 0.8;
    }

    .close {
      color: rgb(255, 255, 255) !important;
      opacity: 0.8;

      &:hover {
        opacity: 1 !important;
        color: rgb(255, 255, 255) !important;
      }
    }
  }

  .feature-card {
    margin: 0px;
    padding: 15px 30px;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: 0 10px 51px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    height: 100%;
  }

  .feature-card .headline {
    color: #3f3561;
    font-size: 23px;
    font-weight: 400;
  }

  .feature-card p, .feature-card ul {
    color: #878694;
    font-family: 'Karla';
    font-size: 0.9em;
    line-height: 18px;
    margin-top: 7px;

  }

  .phone-img {
    background-color: #f8f9fa !important;
    border: 20px solid #f8f9fa;
  }

</style>
